export const INIT = 'app/DonationsListPage/INIT';
export const INIT_SUCCESS = 'app/DonationsListPage/INIT_SUCCESS';
export const INIT_FAILED = 'app/DonationsListPage/INIT_FAILED';

export const FETCH_SUCCESS = 'app/DonationsListPage/FETCH_SUCCESS';
export const FETCH_FAILED = 'app/DonationsListPage/FETCH_FAILED';

export const SET_FETCH_PARAMS = 'app/DonationsListPage/SET_FETCH_PARAMS';

export const SELECT_DONATION = 'app/DonationsListPage/SELECT_DONATION';
export const OPEN_OVERVIEW = 'app/DonationsListPage/OPEN_OVERVIEW';
export const CLOSE_OVERVIEW = 'app/DonationsListPage/CLOSE_OVERVIEW';
export const MATCH_DONATIONS = 'app/DonationsListPage/MATCH_DONATIONS';
export const MATCH_DONATIONS_SUCCESS = 'app/DonationsListPage/MATCH_DONATIONS_SUCCESS';
export const MATCH_DONATIONS_FAILED = 'app/DonationsListPage/MATCH_DONATIONS_FAILED';
export const UNMATCH_DONATIONS = 'app/DonationsListPage/UNMATCH_DONATIONS';
export const UNMATCH_DONATIONS_SUCCESS = 'app/DonationsListPage/UNMATCH_DONATIONS_SUCCESS';
export const UNMATCH_DONATIONS_FAILED = 'app/DonationsListPage/UNMATCH_DONATIONS_FAILED';
export const CANCEL_CORPORATE_DONATION = 'app/DonationsListPage/CANCEL_CORPORATE_DONATION';
export const CANCEL_CORPORATE_DONATION_SUCCESS =
  'app/DonationsListPage/CANCEL_CORPORATE_DONATION_SUCCESS';
export const CANCEL_CORPORATE_DONATION_FAILED =
  'app/DonationsListPage/CANCEL_CORPORATE_DONATION_FAILED';

export const FORM_IDENTIFIER = 'app/DonationsListPage';
